import { ActivityV1Type } from "@pages/Contents/V2/Corporate/Catalog/AddActivity/types";
import { ACTIVITY } from "@utils/constants";

export const isClassroom = (activity: ActivityV1Type) =>
  activity === ACTIVITY.DA_PHYSICAL_CLASS ||
  activity === ACTIVITY.DA_VIRTUAL_CLASS;
